var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiple15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 19v1h14v-1h2v3H3v-3h2zM15.403 7.14v1.75h-3.695l-.236 2.022c.175-.13.397-.234.667-.314.27-.08.565-.124.884-.133.863-.018 1.528.259 1.994.83.466.573.699 1.384.699 2.434 0 .939-.26 1.719-.779 2.34-.519.62-1.336.931-2.45.931-.885 0-1.654-.244-2.307-.731s-.967-1.131-.941-1.933l.006-.04 2.112-.133c0 .343.104.612.31.808.206.195.48.293.82.293.4 0 .678-.126.836-.38.157-.254.236-.634.236-1.142 0-.534-.092-.954-.275-1.261-.182-.307-.472-.461-.867-.461-.285 0-.516.065-.693.194-.176.129-.298.291-.367.487l-1.933-.114.536-5.447h5.443zM8 15v2H6v-2h2zM5.026 7v9.86H2.87V9.07H1V7.346L5.026 7zm13.73 2.637l.843 2.13h.038l.874-2.13h2.419l-2.004 3.571L23 16.86h-2.418l-.92-2.196h-.038l-.918 2.196h-2.419l2.074-3.652-2.01-3.571h2.406zM21 1v3h-2V3H5v1H3V1h18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiple15);
export default __webpack_public_path__ + "static/media/multiple-1-5.63f4e762.svg";
export { ForwardRef as ReactComponent };